module.exports = __webpack_public_path__ + "img/game_rank_rule.a5bc3fdf.png";